import React, { FC } from 'react';
import { DrivingRecordByDayOrTime } from './DrivingRecordByDayOrTime/DrivingRecordByDayOrTime';

export const DrivingRecordByDayOrTimePage: FC = () => {
  return <DrivingRecordByDayOrTime />;
};
